import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ui-drawer-button',
  templateUrl: './drawer-button.component.html',
  styleUrl: './drawer-button.component.scss',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
})
export class DrawerButtonComponent {
  @Output() buttonClicked = new EventEmitter();
  @Input() drawerOpened: boolean;

  emitButtonClicked(): void {
    this.buttonClicked.emit();
  }
}
